// extracted by mini-css-extract-plugin
export default {"wrap":"PDF_wrap__na7uS"};